/**
 * Blog listing: filter panel (collapsible groups + auto-apply) and the filters
 * sidebar (desktop collapse persisted to localStorage; mobile drawer).
 */
function init($) {
    // ─── Filter panel: collapsible groups ────────────────────────────────────
    $('[data-filter-toggle]').on('click', function () {
        var $btn = $(this);
        var $group = $btn.closest('[data-filter-group]');
        var expanded = $btn.attr('aria-expanded') === 'true';

        $group.toggleClass('blog-filter__group--open', !expanded);
        $btn.attr('aria-expanded', String(!expanded));
    });

    // ─── Filters: auto-apply on change ───────────────────────────────────────
    // Facets go in the query string. On article-type/industry pages that facet is
    // fixed by the URL slug (server-side), so both combine.
    function applyFilters() {
        var $form  = $('#blog-filter-form');
        var params = new URLSearchParams();

        $form.find('input[name="articleType[]"]:checked').each(function () { params.append('articleType[]', this.value); });
        $form.find('input[name="industry[]"]:checked').each(function ()    { params.append('industry[]',    this.value); });
        $form.find('input[name="author[]"]:checked').each(function ()   { params.append('author[]',   this.value); });

        var published = $form.find('input[name="published"]:checked').val() || '';
        var reading   = $form.find('input[name="reading"]:checked').val()   || '';
        var sort      = $form.find('input[name="sort"]').val()              || 'recent';

        if (published)                 params.append('published', published);
        if (reading)                   params.append('reading',   reading);
        if (sort && sort !== 'recent') params.append('sort',      sort);

        var qs = params.toString();
        // Stay on the current path so a slug-fixed facet combines with these filters.
        window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    }

    // Desktop auto-applies on each change. On mobile the panel is a modal with
    // an explicit "Show articles" button, so changes are batched until submit.
    $('#blog-filter-form').on('change', 'input', function () {
        if (window.matchMedia('(max-width: 767px)').matches) { return; }
        applyFilters();
    });
    // Submit = the mobile "Show articles" button (and guards a stray Enter).
    $('#blog-filter-form').on('submit', function (e) { e.preventDefault(); applyFilters(); });

    // ─── Filters sidebar: desktop collapse + mobile drawer ────────────────────
    var $layout    = $('#blog-listing-layout');
    var $toggle    = $('#filter-toggle-btn');    // re-opens (in toolbar)
    var $collapse  = $('#filter-collapse-btn');  // desktop collapse (sidebar head)
    var $close     = $('#filter-close-btn');     // mobile close ✕ (sidebar head)
    if (!$layout.length) { return; }

    var COLLAPSE_KEY = 'blogFiltersCollapsed';
    function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

    // Restore persisted desktop collapsed state.
    try {
        if (localStorage.getItem(COLLAPSE_KEY) === '1') {
            $layout.addClass('blog-listing-layout--collapsed');
            $toggle.attr('aria-expanded', 'false');
        }
    } catch (e) {}

    function setMobileSheet(open) {
        $layout.toggleClass('blog-listing-layout--mobile-open', open);
        $('body').toggleClass('blog-filters-open', open);
        $toggle.attr('aria-expanded', String(open));
    }

    $toggle.on('click', function () {
        if (isMobile()) {
            setMobileSheet(!$layout.hasClass('blog-listing-layout--mobile-open'));
        } else {
            $layout.removeClass('blog-listing-layout--collapsed');
            $toggle.attr('aria-expanded', 'true');
            try { localStorage.setItem(COLLAPSE_KEY, '0'); } catch (e) {}
        }
    });

    $collapse.on('click', function () {
        if (isMobile()) {
            setMobileSheet(false);
        } else {
            $layout.addClass('blog-listing-layout--collapsed');
            $toggle.attr('aria-expanded', 'false');
            try { localStorage.setItem(COLLAPSE_KEY, '1'); } catch (e) {}
            $toggle.trigger('focus');
        }
    });

    // Mobile close ✕ — dismiss the filters sheet without applying.
    $close.on('click', function () {
        setMobileSheet(false);
        $toggle.trigger('focus');
    });
}

module.exports = { init };
